module.exports = __webpack_public_path__ + "static/img/4-5.ea76830.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/4-5.jpg
// module id = z1VU
// module chunks = 25